import React, { createContext, useContext, ReactNode } from 'react';
import { Address } from 'types';
import {
  AddressInputState,
  AddressInputData,
  SmartyStreetsAutocompleteSuggestion,
} from 'hooks/address';

interface SingleLineAddressInputContextValue {
  // State machine
  state: AddressInputState;
  data: AddressInputData;

  // Actions
  onSelectAddress: (address: Address) => void;
  onContinue: () => void;
  onReset: () => void;
  onEnterUnit: (unit: string) => void;

  // Autocomplete
  suggestions: SmartyStreetsAutocompleteSuggestion[];
  isLoadingSuggestions: boolean;
  onSearchAddress: (query: string) => void;
  clearSuggestions: () => void;

  // Validation
  isValidating: boolean;

  // API Key (for subcomponents)
  smartyApiKey: string;
}

const SingleLineAddressInputContext = createContext<
  SingleLineAddressInputContextValue | undefined
>(undefined);

export function useSingleLineAddressInputContext() {
  const context = useContext(SingleLineAddressInputContext);
  if (!context) {
    throw new Error(
      'useSingleLineAddressInputContext must be used within SingleLineAddressInput'
    );
  }
  return context;
}

interface SingleLineAddressInputProviderProps {
  value: SingleLineAddressInputContextValue;
  children: ReactNode;
}

export function SingleLineAddressInputProvider({
  value,
  children,
}: SingleLineAddressInputProviderProps) {
  return (
    <SingleLineAddressInputContext.Provider value={value}>
      {children}
    </SingleLineAddressInputContext.Provider>
  );
}
